export default {
  header: {
    projectName: 'Nombre del Proyecto',
    export: 'Exportar',
    debug: 'Depurar',
    success: 'Éxito',
    failed: 'Fallido',
    generating: 'Generando video...',
    updateNameFailed: 'Error al actualizar el nombre del proyecto',
    menu: 'Menú',
    settings: 'Configuración',
    shortcuts: 'Atajos de teclado',
    about: 'Acerca de',
    darkMode: 'Modo Oscuro',
    lightMode: 'Modo Claro',
    settingsComingSoon: 'Próximamente: Configuración',
    shortcutsComingSoon: 'Próximamente: Atajos de teclado',
    aboutComingSoon: 'Próximamente: Acerca de',
    language: 'Idioma',
    dimensions: 'Dimensiones',
    canvas: 'Lienzo',
    view: 'Vista',
    general: 'General'
  },
  menu: {
    media: 'Medios',
    text: 'Texto'
  },
  loading: {
    core: 'Cargando Núcleo...'
  },
  home: {
    title: 'GeminiXiang Studio',
    version: 'Beta Pública',
    betaDisclaimer: 'Versión beta, persistencia de datos no garantizada',
    newProject: 'Nuevo Proyecto',
    backupFolder: 'Carpeta de Respaldo',
    documentation: 'Documentación',
    recentProjects: 'Proyectos Recientes',
    viewAll: 'Ver todos ({count})',
    noProjects: 'No hay proyectos aún. ¡Crea tu primer proyecto para comenzar!',
    login: 'INICIAR SESIÓN',
    github: 'GITHUB',
    discord: 'DISCORD',
    blog: 'BLOG',
    projectCreated: 'Proyecto Creado',
    projectCreatedDesc: 'Nuevo proyecto creado exitosamente',
    projectDeleted: 'Proyecto Eliminado',
    projectDeletedDesc: 'Proyecto eliminado exitosamente',
    deleteConfirmation: '¿Estás seguro de que quieres eliminar este proyecto? Esta acción no se puede deshacer.',
    migrationFailed: 'Migración Fallida',
    migrationFailedDesc: 'Error al migrar datos desde localStorage',
    loadFailed: 'Error de Carga',
    loadFailedDesc: 'Error al cargar proyectos',
    creationFailed: 'Error de Creación',
    creationFailedDesc: 'Error al crear nuevo proyecto',
    deletionFailed: 'Error de Eliminación',
    deletionFailedDesc: 'Error al eliminar proyecto'
  },
  timeline: {
    autoSaveFailed: 'Autoguardado fallido',
    autoSaveFailedDesc: 'Error al autoguardar el proyecto',
    loadFailed: 'Error de Carga',
    loadFailedDesc: 'Error al cargar proyecto. Redirigiendo al inicio...',
    mainTrack: 'Pista Principal',
    undo: 'Deshacer',
    redo: 'Rehacer',
    split: 'Dividir',
    delete: 'Eliminar'
  },
  attributes: {
    properties: 'Propiedades',
    position: 'Posición',
    scale: 'Escala',
    animation: 'Animación',
    basic: 'Básico',
    mute: 'Silenciar',
    text: 'Texto',
    fontSize: 'Tamaño de Fuente',
    content: 'Contenido',
    fontFamily: 'Familia de Fuentes',
    direction: 'Dirección del Texto',
    color: 'Color',
    stroke: 'Trazo',
    background: 'Fondo',
    video: 'Video',
    rotate: 'Rotar',
    backgroundColor: 'Color de Fondo',
    opacity: 'Opacidad',
    blend: 'Mezcla',
    filter: 'Filtro',
    effect: 'Efecto',
    transition: 'Transición',
    speed: 'Velocidad',
    volume: 'Volumen'
  },
  router: {
    editor: 'Editor de Video',
    preview: 'Vista Previa',
    storyboard: 'Storyboard - Agente de Video IA'
  },
  placeholder: {
    text: 'Por favor ingrese contenido de texto',
    input: 'Por favor ingrese'
  },
  error: {
    parseAudio: 'Error al analizar audio',
    parseImage: 'Error al analizar imagen',
    parseVideo: 'Error al analizar video',
    noProject: 'Por favor cree o abra un proyecto primero',
    invalidFileType: 'Tipo de archivo inválido'
  },
  media: {
    video: 'Video',
    image: 'Imagen',
    audio: 'Audio',
    dropToUpload: 'Arrastre archivos aquí para subir'
  },
  common: {
    defaultText: 'Texto Predeterminado',
    delete: 'Eliminar'
  }
};
